import { DOTS, usePaginationData } from 'src/hooks/usePagination';
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface IPaginationProps {
    onPageChange: (page: number) => void;
    totalCount: number;
    siblingCount: number;
    currentPage: number;
    pageSize: number;
}

export const PaginationComponent: FC<IPaginationProps> = (props) => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
    } = props;

    const paginationRange = usePaginationData({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });
    const { t } = useTranslation("common");

    const RecordsCount = () => {
        if (totalCount > 10) {
            const startRecord = (currentPage - 1) * pageSize + 1;
            const endRecord = Math.min(currentPage * pageSize, totalCount);

            return (
                <div>
                    {t("pagination.lblStartItem")} {startRecord} {t("pagination.lblBetween")} {endRecord} {t("pagination.lblEndItem")} {totalCount}{" "}
                    {totalCount === 1 ? t("pagination.lblTotalRecord") : t("pagination.lblTotalRecords")}
                </div>
            );
        } else if (totalCount > 0 && totalCount <= 10) {
            return (
                <div>
                    {totalCount}{" "}
                    {totalCount === 1
                        ? t("pagination.record")
                        : t("pagination.records")}{" "}
                    {t("pagination.found")}
                </div>
            );
        } else {
            return <div>{t("pagination.noRecordFound")}</div>;
        }
    };

    const onNext = () => {
        if ((pageSize * currentPage) >= totalCount) {
            return;
        }
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        if (currentPage === 1) {
            return;
        }
        onPageChange(currentPage - 1);
    };

    return (
        <div className="hstack record-left gap-1 flex-wrap my-2">

            <RecordsCount />
            <ul
                className="pagination cs-pagination mb-0 ms-2"
            >
                {
                    paginationRange?.length > 0 && (
                        <li className="page-item">
                            <button className="page-link" onClick={onPrevious}>&laquo;</button>
                        </li>
                    )
                }
                {paginationRange.map((pageNumber, i) => {
                    if (pageNumber === DOTS) {
                        return (
                            <li className="page-item" key={`pagination-el-${pageNumber}-${i}`}>
                                <button
                                    className="page-link"
                                >...</button>
                            </li>
                        )
                    }

                    return (
                        <li key={`pagination-el-${pageNumber}-${i}`} className={`page-item ${pageNumber === currentPage ? 'active' : ''} `}>
                            <button
                                className="page-link"
                                onClick={() => onPageChange(Number(pageNumber))}
                            >{pageNumber}</button>
                        </li>

                    );
                })}
                {
                    paginationRange?.length > 0 && (
                        <li className="page-item">
                            <button className="page-link" onClick={onNext}>&raquo;</button>
                        </li>
                    )
                }
            </ul>
        </div>
    );
};